export enum FileMode {
    Shared = 0,
    Exclusive = 1,
    ReadOnly = 2
}